import React from 'react';

const LegalTexts: React.FC = () => {
  return (
    <section id="legal" className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-3">Textos legales</h2>
        <p className="text-gray-600 mb-8">
          Información legal y de privacidad aplicable al sitio web fernandopinilla.com.
        </p>

        <div className="space-y-4">
          <details className="border border-gray-200 rounded-lg p-5">
            <summary className="cursor-pointer font-semibold text-gray-900">Aviso legal</summary>
            <div className="mt-4 text-sm text-gray-700 space-y-3">
              <p>
                Titular del sitio web: Fernando Javier Pinilla Barrena. Contacto: fpinilla@synapse.es.
                Domicilio profesional: Mérida, Badajoz, España.
              </p>
              <p>
                El acceso y uso de esta web atribuye la condición de usuario e implica la aceptación de este aviso legal.
                El usuario se compromete a utilizar los contenidos y servicios de forma lícita.
              </p>
              <p>
                Los contenidos, diseño y código fuente están protegidos por derechos de propiedad intelectual e industrial.
                No se permite su reproducción total o parcial sin autorización expresa del titular.
              </p>
              <p>
                El titular no se responsabiliza de daños derivados del uso indebido de la web ni de enlaces externos de terceros.
              </p>
            </div>
          </details>

          <details className="border border-gray-200 rounded-lg p-5">
            <summary className="cursor-pointer font-semibold text-gray-900">Política de privacidad</summary>
            <div className="mt-4 text-sm text-gray-700 space-y-3">
              <p>
                Responsable del tratamiento: Fernando Javier Pinilla Barrena. Finalidad: atender contactos profesionales
                y analizar de forma agregada el uso de la web para mejorar contenidos y rendimiento.
              </p>
              <p>
                Base jurídica: consentimiento del usuario para la analítica opcional y, en su caso, interés legítimo para
                mantener la seguridad y funcionamiento técnico del sitio.
              </p>
              <p>
                Conservación: los datos de analítica se almacenan en registros internos con retención limitada y medidas
                de minimización (IP anonimizada y datos agregados en backoffice).
              </p>
              <p>
                Derechos: puedes solicitar acceso, rectificación, supresión, oposición o limitación escribiendo a
                fpinilla@synapse.es.
              </p>
            </div>
          </details>

          <details className="border border-gray-200 rounded-lg p-5">
            <summary className="cursor-pointer font-semibold text-gray-900">Política de cookies</summary>
            <div className="mt-4 text-sm text-gray-700 space-y-3">
              <p>
                Esta web usa almacenamiento local/cookies técnicas para guardar tu preferencia de consentimiento.
                Si aceptas, también se registran eventos de analítica de visitas (página, procedencia UTM/referrer,
                dispositivo y geolocalización aproximada por cabecera de red).
              </p>
              <p>
                Cookies técnicas (siempre activas): necesarias para recordar tu elección de privacidad y mantener la sesión.
                Cookies de analítica (opcionales): permiten medir tráfico y procedencia para mejorar el sitio.
              </p>
              <p>
                Puedes cambiar tu consentimiento en cualquier momento desde el botón "Preferencias de cookies" visible en la web.
              </p>
            </div>
          </details>
        </div>
      </div>
    </section>
  );
};

export default LegalTexts;
